<template>
  <div>
    <layout-header title="Trámite EFS (EEFF/SEAFI)" subtitle="Informe sobre la situación económica de las ESI">
      <ets-button v-if="isAllowed" icon="add" @click="generateReport" />
    </layout-header>
    <ets-page>
      <template v-if="isAllowed">
        <ets-alert type="info">Presentar antes de: 20 de enero (E1) y 15 de mayo (E2)</ets-alert>
        <download-section v-if="isAllowed" ref="downloadSection" procedure="seafi" />
      </template>
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import DownloadSection from "@/components/Download/DownloadSection";
import Forbidden from "@/components/Forbidden";

export default {
  name: "PageSolvency",
  components: {
    LayoutHeader,
    DownloadSection,
    Forbidden
  },
  computed: {
    ...mapState(["userPermissions"]),
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_E_ProcedureSEAFI;
    }
  },
  methods: {
    generateReport() {
      this.$refs.downloadSection.initGenerationNewFile();
    }
  }
};
</script>
